var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBqSe = function SvgBqSe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M5.237 21.913A11.944 11.944 0 0 0 12.001 24c2.509 0 4.837-.77 6.763-2.087l-6.763-1.044-6.764 1.044ZM18.764 2.087A11.944 11.944 0 0 0 12.001 0C9.49 0 7.163.77 5.237 2.087l6.764 1.044 6.763-1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M5.237 21.913A11.944 11.944 0 0 0 12.001 24c2.509 0 4.837-.77 6.763-2.087l-6.763-1.044-6.764 1.044ZM18.764 2.087A11.944 11.944 0 0 0 12.001 0C9.49 0 7.163.77 5.237 2.087l6.764 1.044 6.763-1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M23.97 11.216c-.284-3.703-2.534-7.304-5.205-9.13H5.238a11.99 11.99 0 0 0-5.212 9.13L12.001 12l11.97-.783ZM.025 12.782a11.99 11.99 0 0 0 5.212 9.13h13.527a11.99 11.99 0 0 0 5.21-9.13L12 12l-11.975.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.97 11.217H12.782V1.565h-1.566v9.652H.025a12.194 12.194 0 0 0 0 1.566h11.192v9.652h1.566v-9.652h11.192c.016-.26.025-.52.025-.783 0-.261-.01-.522-.03-.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m4.696 12 7.305-4.592L19.305 12l-7.304 4.591L4.696 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M7.826 14.087h9.391l-2.086-3.13L14.086 12l-1.043-.521L12 13.044H9.913L8.87 12l-1.044 2.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 8.869.26.797h.838l-.679.493.26.797-.679-.493-.678.493.26-.797-.679-.493h.838l.26-.797Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m12 6.097-9.39 5.902L12 17.902 21.393 12l-9.391-5.902Zm-6.45 5.902L12 7.945 18.45 12 12 16.053 5.55 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBqSe;